import { Injectable } from '@angular/core';
import { ApiService, RepositoryImpl } from '@homeleite/arch';
import { Controller, ControllerSummary } from './controller';
import { ProducerSummary } from '../producers/producer';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ControllersApiRepository extends RepositoryImpl<ControllerSummary, Controller> {
    constructor(api: ApiService) {
        super(api.root.path('/controllers'), ControllerSummary, Controller);
    }

    override update(controller: Controller): Observable<Controller> {
        return super.update(controller).pipe(
            tap(updatedController => {
                (this as any).cache?.set(updatedController.id, updatedController);
            })
        );
    }

    deactivate(value: Controller): Observable<Controller> {
        return this.api.path(`/${value.id}/deactivate`).postJson(null).pipe(
            map(() => {
                value.active = false;
                return value;
            }),
            tap(() => (this as any).cache?.set(value.id, value))
        );
    }

    override activate(controller: Controller): Observable<Controller> {
        return this.api.path(`/${controller.id}/activate`).postJson(null).pipe(
            map(() => {
                controller.active = true;
                return controller;
            }),
            tap(() => (this as any).cache?.set(controller.id, controller))
        );
    }
}
